import DashboardOnboardedContainer from "./DashboardOnboardedContainer";
import DashboardOnboardedStore from "./DashboardOnboardedStore";

export default DashboardOnboardedStore(DashboardOnboardedContainer);